module.exports = __webpack_public_path__ + "img/otp-bank.2fd06342.svg";